<template>
  <div class="gc-status-chip">
    <label
      v-bind:class="{
        active:
          status.toFriendlyStatus() == 'Active' ||
          status.toFriendlyStatus() == 'Printed' ||
          status.toFriendlyStatus() == 'Awaiting Receipt',
        inProgess: status.toFriendlyStatus() == 'In Progress',
        approved: status.toFriendlyStatus() == 'Approved',
        completed:
          status.toFriendlyStatus() == 'Completed' ||
          status.toFriendlyStatus() == 'Complete' ||
          status.toFriendlyStatus() == 'Invoiced' ||
          status == 'Complete',
        cancelled:
          status.toFriendlyStatus() == 'Cancelled' ||
          status.toFriendlyStatus() == 'Credit Hold' ||
          status.toFriendlyStatus() == 'Closed' ||
          status.toFriendlyStatus() == 'Cash Before Despatch',
        draft: status.toFriendlyStatus() == 'Draft' || status == 'Prepared',
        pending: status.toFriendlyStatus() == 'Pending',
        locked: status.toFriendlyStatus() == 'Locked',
        enquiry: status.toFriendlyStatus() == 'Enquiry',
        new:
          status.toFriendlyStatus() == 'New' ||
          status.toFriendlyStatus() == 'Edit',
        open: status.toFriendlyStatus() == 'Open' || status == 'Open',
        paid: status.toFriendlyStatus() == 'Paid',
        overdue: status.toFriendlyStatus() == 'Overdue',
        credited: status.toFriendlyStatus() == 'Credited',
        credit: status.toFriendlyStatus() == 'Credit',
        allocated: status.toFriendlyStatus() == 'Allocated',
        unallocated: status.toFriendlyStatus() == 'Unallocated',
        reconciled: status.toFriendlyStatus() == 'Reconciled',
        unpresented:
          status.toFriendlyStatus() == 'Unpresented' ||
          status.toFriendlyStatus() == 'Uncommitted Reconciliation',
        pendingInvoice: status.toFriendlyStatus() == 'Pending Invoice',
        failed:
          status.toFriendlyStatus() == 'FAILED' ||
          status.toFriendlyStatus() == 'Failed',
        queued:
          status.toFriendlyStatus() == 'QUEUED' ||
          status.toFriendlyStatus() == 'Queued' ||
          status.toFriendlyStatus() == 'Partially Received',
        onhold: status.toFriendlyStatus() == 'On Hold',
        sent:
          status.toFriendlyStatus() == 'SENT' ||
          status.toFriendlyStatus() == 'Sent',
        compliant: status.toFriendlyStatus() == 'Compliant',
        notCompliant: status.toFriendlyStatus() == 'Not Compliant',
        incomplete:
          status.toFriendlyStatus() == 'Incomplete' ||
          status.toFriendlyStatus() == 'Not Reconciled',
        notified: status == 'Notified',
        return:
          status.toFriendlyStatus() == 'Return' ||
          status.toFriendlyStatus() == 'Returned',
        inproduction: status.toFriendlyStatus() == 'In Production',
      }"
      >{{ status.toFriendlyStatus() }}</label
    >
  </div>
</template>

<script>
export default {
  props: {
    status,
  },
};
</script>

<style lang="scss" scoped>
.gc-status-chip label {
  padding: 1px 5px;
  min-width: 76px;
}
label {
  display: block;
  color: white;
  background: #e2e2e2;
  border-radius: 8.5px;
  padding: 1px 5px;
  height: 17px !important;
  font-size: 11px;
  line-height: 1.5 !important;
  text-align: center;
  // margin: 5px;
}

.active,
.compliant,
.reconciled {
  background: #62d26f;
}

.inProgess {
  background: #62d26f;
}
/* TODO: find out the correct color codes for statuses */
.draft,
.notCompliant,
.unpresented {
  background-color: #eec300;
}

.new {
  background-color: #eec300;
}

.approved {
  background-color: #62d26f;
}
.credit,
.cancelled,
.incomplete,
.failed,
.return {
  background-color: #e8384f;
}

.completed {
  background-color: #4186e0;
}

.locked {
  background-color: #aa62e3;
}

.pending {
  background-color: #800080;
}

.enquiry,
.queued,
.inproduction {
  background-color: #ffa500;
}

.open {
  background: #ffa500;
}

.onhold {
  background: #ffa500;
}

.paid,
.sent {
  background-color: #62d26f;
}

.overdue {
  background-color: #e8384f;
}

.credited {
  background-color: #e8384f;
}

.allocated {
  background-color: #38b0e8;
}

.unallocated {
  background-color: #5b6b6ba1;
}

.pendingInvoice {
  background-color: #aa62e3;
}

.notified {
  background-color: #04c3a9;
}
</style>
